// extracted by mini-css-extract-plugin
export default {"loaderDefault":"styles_loaderDefault__iDkhE","loaderDanger":"styles_loaderDanger__glBh2"};